import PagePublic from '../../components/Page/PagePublic';
import Grid from '@mui/material/Grid';
//import Box from '@mui/material/Box';
//import Typography from '@mui/material/Typography';
import {Linkgroup} from '../../components/Header/Linkgroup'
import RegisterCard from './RegisterCard';
import OnboardingSteps from '../../ProtectedPages/MainWelcome/Onboarding/Steps/OnboardingSteps'

export default function RegisterPage() {

    return (

        
    <PagePublic linkgroup={<> <Linkgroup destination="/" button_name='HOME' />  </>}
    
    main={ 
    
     
        
          <Grid container spacing={2}>
        
              <Grid size={{ xs: 12, md: 6 }} sx={{p:4, display: 'flex', justifyContent: 'center', alignItems: 'center' }}> <OnboardingSteps /> </Grid> 
        
              <Grid size={{ xs: 12, md: 6 }} sx={{p:2, display: 'flex', justifyContent: 'center' }}> <RegisterCard />  </Grid> 
        
        </Grid>
   
    }
/>
  )
}